import React, { useEffect, useState } from 'react';

import GitAidTable from './GiftAidTable'
import { getGiftAidList } from '../sundayupdates/NoticeUpdateService';
import { insertGiftAidData } from '../../Guest/GuestApiServices';

const GiftAidList = () => {
  
    const[giftAidList,setGiftAidList] = useState([]);

  useEffect(() => {

    loadgiftAidList();

  }, []);


  const onDeleteGiftAid = (id) => {

    let data = {
      id: id
    }

    insertGiftAidData(data).then((response) => {
      if (response.data.success) {
        console.log(response.data.data);
        alert("deleted");
        loadgiftAidList();
      }
    }).catch((error) => {
        console.log("some error",error);
    })
  }

   const loadgiftAidList = () => {
    
    getGiftAidList().then((response) => {
      if (response.data.success) {
        console.log(response.data.data);
        setGiftAidList(response.data.data)
      }
    }).catch((error) => {
      setGiftAidList([])
    })
  }



  return (
    <div className="container py-4">
      <h2 className="text-center mb-4">Gift Aid List</h2>
      <div className="row">
        <div className="col-12">
          <GitAidTable
            list={giftAidList}
            onDelete={(id)=>{onDeleteGiftAid(id)}}
          />
        </div>
      </div>
    </div>
  );
};

export default GiftAidList;